<template>
<div class="content2">
  <div class="header">
    <el-date-picker
      style="width: 120px"
      v-model="where2.year_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="选择月份">
    </el-date-picker>
    <el-button @click="exportExcel">导出报表</el-button>
  </div>
  <div class="body">
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="pageData" :data="pageData.list"
        border class="table-wrap-table" height="60vh">
        <el-table-column label="名称" prop="name" align="center" width="180" fixed="left"></el-table-column>
        <el-table-column label="当月计划" prop="plan_count" align="center" width="100"></el-table-column>
        <el-table-column label="待审核" align="center">
          <el-table-column label="提交" prop="tj_count_1" align="center" width="100"></el-table-column>
          <el-table-column label="诉调" prop="st_count_1" align="center" width="100"></el-table-column>
          <el-table-column label="立案" prop="la_count_1" align="center" width="100"></el-table-column>
          <el-table-column label="小计" prop="count_1" align="center" width="100"></el-table-column>
        </el-table-column>
        <el-table-column label="审核中" align="center">
          <el-table-column label="提交" prop="tj_count_2" align="center" width="100"></el-table-column>
          <el-table-column label="诉调" prop="st_count_2" align="center" width="100"></el-table-column>
          <el-table-column label="立案" prop="la_count_2" align="center" width="100"></el-table-column>
          <el-table-column label="小计" prop="count_2" align="center" width="100"></el-table-column>
        </el-table-column>
        <el-table-column label="已审核" align="center">
          <el-table-column label="提交" prop="tj_count_3" align="center" width="100"></el-table-column>
          <el-table-column label="诉调" prop="st_count_3" align="center" width="100"></el-table-column>
          <el-table-column label="立案" prop="la_count_3" align="center" width="100"></el-table-column>
          <el-table-column label="自催缴费" prop="zc_count_3" align="center" width="100"></el-table-column>
          <el-table-column label="成功缴费" prop="cg_count_3" align="center" width="100"></el-table-column>
          <el-table-column label="小计" prop="count_3" align="center" width="100"></el-table-column>
        </el-table-column>
        <el-table-column label="驳回" align="center">
          <el-table-column label="提交" prop="tj_count_4" align="center" width="100"></el-table-column>
          <el-table-column label="诉调" prop="st_count_4" align="center" width="100"></el-table-column>
          <el-table-column label="立案" prop="la_count_4" align="center" width="100"></el-table-column>
          <el-table-column label="小计" prop="count_4" align="center" width="100"></el-table-column>
        </el-table-column>
        <el-table-column label="合计" prop="total_count" align="center" width="100"></el-table-column>
      </el-table>
    </div>
<!--    <div class="pagination-wrap">-->
<!--      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"-->
<!--                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"-->
<!--                     @current-change="pageChange"></el-pagination>-->
<!--    </div>-->
  </div>
</div>
</template>

<script>
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";

export default {
  name: "RecordFilingStatusStatisticsTable",
  inject:['where','reginWhere'],
  props: {
    type:{
      type:String,
      default:''
    }
  },
  data() {
    return{
      where2:{
        year_month:moment().format("YYYY-MM"),
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.year_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  methods: {
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        type:that.type,
        level:that.reginWhere.level,
      }

      ButlerHttp.post("ProjectCollectionProceedingRecord/index2",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          res.data.list.map(ret => {

            // ret.is_invoice=ret.is_invoice === 1;
            // ret.is_paid=ret.is_paid === 1;
            return ret;
          })
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        type:that.type,
        level:that.reginWhere.level,
      }
      ButlerHttp.post("StatisticalTable/projectCollectionProceedingRecordExcel",{
        ...where,
      },res => {
        loading.close()
        if (res.code) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/report_forms/RecordFilingStatusStatisticsTable.vue